import ky, {
  BeforeRequestHook,
  AfterResponseHook,
  NormalizedOptions,
} from "ky";
import router from "@/router/index";
let url = "https://liz10test.ipcomnetwork.net/api";

import store from "@/store";
import { AuthState } from "@/store/auth";
import { OrejasUser } from "@/store/users";

if (process.env.VUE_APP_BE_URL) {
  url = process.env.VUE_APP_BE_URL;
}

const authReqHook: BeforeRequestHook = async function (request) {
  const authstore = ((store.state as unknown) as any).auth as AuthState;
  try {
    if (authstore.currentUser.firebaseUser) {
      const token = await authstore.currentUser.firebaseUser!.getIdToken();
      request.headers.set("Authorization", `Bearer ${token}`);
    }
  } catch (err) {
    store.commit("auth/CLEAR_ALL");
  }
};

const statusValidationHook: AfterResponseHook = async function (
  request: Request,
  options: NormalizedOptions,
  response: Response
) {
  if (response.status == 403) {
    if (router.currentRoute.path != "/ip-Invalid") {
      router.push({ path: "ip-Invalid" });
    }
  }
};

export async function authorizeUrlApi(url: string): Promise<string> {
  const authstore = ((store.state as unknown) as any).auth as AuthState;
  const token = await authstore.currentUser.firebaseUser!.getIdToken();
  return `${url}?Authorization=Bearer ${token}`;
}

export const client = ky.extend({
  retry: {
    limit: 1,
    methods: ["put"],
  },
  prefixUrl: url,
  hooks: {
    beforeRequest: [authReqHook],
    afterResponse: [statusValidationHook],
  },
});

export function httpByCurrentCustomer(): typeof ky {
  return ky.extend({
    prefixUrl: `${getUrlBase()}`,
    hooks: {
      beforeRequest: [authReqHook],
      afterResponse: [statusValidationHook],
    },
    timeout: 120000,
  });
}

export function getUrlBase(): string {
  const currentUser = (store.state as any).auth.currentUser.user as OrejasUser;
  if (currentUser) {
    return `${url}/customer/${currentUser.customerCurrent.customerId}`;
  }
  return url;
}

export function downloadFromBlob(blob: Blob, name: string) {
  const a = document.createElement("a");
  a.style.display = "none";
  document.body.appendChild(a);
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = name;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

export function authClient(token: string) {
  return ky.extend({
    prefixUrl: url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function isAuthError(err?: ky.HTTPError): boolean {
  return err?.response?.status === 401;
}
